import { Icons } from "assets";
import classNames from "classnames";
import CustomButton from "shared/components/common/customButton";
import styles from "./styles.module.scss";

interface ProjectNotificationBannerProps {
  title: string;
  description?: string;
  buttonText?: string;
  onButtonClick?: () => void;
  showButton?: boolean;
  // Optional second action ("View Project") rendered next to the primary
  // button — navigates without consuming the notification.
  secondaryButtonText?: string;
  onSecondaryButtonClick?: () => void;
  // When provided, renders an ✕ in the top-right corner so the card can be
  // dismissed without swiping.
  onDismissClick?: () => void;
  // When false, the pulsing scale animation (which changes the box size) is
  // disabled — used inside the carousel where overflow:hidden would clip it.
  animated?: boolean;
}

const ProjectNotificationBanner = ({
  title,
  description = "Your designer has uploaded new plans and is waiting for your feedback. Click below to review the latest revision.",
  buttonText = "Open Latest Revision",
  onButtonClick,
  showButton = true,
  secondaryButtonText,
  onSecondaryButtonClick,
  onDismissClick,
  animated = true,
}: ProjectNotificationBannerProps) => {
  return (
    <div
      className={classNames(
        styles.box,
        !animated && styles.noScale,
        onDismissClick && styles.hasDismiss,
        "flex flex-col gap-3",
      )}
    >
      {onDismissClick && (
        <button
          type="button"
          className={styles.dismiss}
          onClick={onDismissClick}
          aria-label="Dismiss notification"
        >
          <Icons.Cross className={styles.dismissIcon} />
        </button>
      )}
      <h1>{title}</h1>
      <p>{description}</p>
      {(showButton || secondaryButtonText) && (
        <div className="flex flex-wrap items-center gap-2">
          {showButton && (
            <CustomButton
              title={buttonText}
              containerStyle={styles.button}
              titleStyle={styles.title}
              Icon={Icons.ArrowRightCircle}
              iconStyle={styles.icon}
              IconDirection="left"
              onClick={onButtonClick}
            />
          )}
          {secondaryButtonText && (
            <CustomButton
              title={secondaryButtonText}
              containerStyle={styles.buttonSecondary}
              titleStyle={styles.titleSecondary}
              onClick={onSecondaryButtonClick}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default ProjectNotificationBanner;
